import 'reflect-metadata';
import { METADATA_TOKEN } from '../Constants';
export function inject(type) {
    return (target, propertyKey, descriptor) => {
        const options = Reflect.getMetadata(METADATA_TOKEN, target) || { type: 'multiton', dependencies: [] };
        if (!options.type) {
            options.type = 'multiton';
        }
        if (!options.dependencies) {
            options.dependencies = [];
        }
        if (Array.isArray(options.dependencies)) {
            options.dependencies.unshift(type);
        }
        Reflect.defineMetadata(METADATA_TOKEN, options, target);
        return target;
    };
}
